import {
  FoodProjectStatusEnum,
  FoodSessionStatusEnum,
} from "@brewbase/db/types";

export const PROJECT_STATUS_CONFIG: Record<
  FoodProjectStatusEnum,
  { label: string; dot: string }
> = {
  active: { label: "Active", dot: "#81b465" },
  on_hold: { label: "On Hold", dot: "#f08942" },
  completed: { label: "Completed", dot: "#94a3b8" },
};

export type SessionStatusFilter = "all" | FoodSessionStatusEnum;
export const SESSION_STATUS_FILTERS: {
  key: SessionStatusFilter;
  label: string;
}[] = [
  { key: "all", label: "All" },
  { key: FoodSessionStatusEnum.unstarted, label: "Unstarted" },
  { key: FoodSessionStatusEnum.in_progress, label: "In Progress" },
  { key: FoodSessionStatusEnum.review, label: "Review" },
  { key: FoodSessionStatusEnum.completed, label: "Completed" },
];

export const SESSION_STATUS_CONFIG: Record<
  FoodSessionStatusEnum,
  {
    label: string;
    color: string;
    bgColor: string;
    borderColor: string;
    dotColor: string;
  }
> = {
  unstarted: {
    label: "Unstarted",
    color: "text-slate-700",
    bgColor: "bg-slate-100",
    borderColor: "border-slate-300",
    dotColor: "bg-slate-400",
  },
  in_progress: {
    label: "In Progress",
    color: "text-farmless-orange-11",
    bgColor: "bg-farmless-orange-2",
    borderColor: "border-farmless-orange-5",
    dotColor: "bg-farmless-orange-9",
  },
  review: {
    label: "Review",
    color: "text-slate-900",
    bgColor: "bg-slate-50",
    borderColor: "border-slate-400",
    dotColor: "bg-slate-900",
  },
  completed: {
    label: "Completed",
    color: "text-farmless-green-9",
    bgColor: "bg-farmless-green-2",
    borderColor: "border-farmless-green-5",
    dotColor: "bg-farmless-green-8",
  },
};

// "sensory" is the tastings' results; "sensory-setup" what they show and ask.
export const PROJECT_TAB_VALUES = ["sessions", "sensory-setup", "sensory", "benchmark", "analysis"] as const;
export type ProjectTabValue = (typeof PROJECT_TAB_VALUES)[number];

export type ProjectStatusFilter = "all" | FoodProjectStatusEnum;
export const PROJECT_STATUS_FILTERS: {
  key: ProjectStatusFilter;
  label: string;
}[] = [
  { key: "all", label: "All" },
  { key: FoodProjectStatusEnum.active, label: "Active" },
  { key: FoodProjectStatusEnum.on_hold, label: "On Hold" },
  { key: FoodProjectStatusEnum.completed, label: "Completed" },
];
